import API_URL from '../../constants/API_URL.js';
import { message } from 'antd'
const axios = require('axios');
export const PARAMETERS_LIST = 'PARAMETERS_LIST'
export const PARAMETERS_BY_CLIENT = 'PARAMETERS_BY_CLIENT'
export const PARAMETERS_BY_ID = 'PARAMETERS_BY_ID'
export const PARAMETERS_BY_ID_PROGRESS = 'PARAMETERS_BY_ID_PROGRESS'
export const PARAMETERS_LIST_PROGRESS = 'PARAMETERS_LIST_PROGRESS'
export const PARAMETERS_BY_CLIENT_PROGRESS = 'PARAMETERS_BY_CLIENT_PROGRESS'
export const PARAMETERS_LIST_BY_PARATYPE_PROGRESS = 'PARAMETERS_LIST_BY_PARATYPE_PROGRESS'
export const PARAMETERS_LIST_BY_PARATYPE = 'PARAMETERS_LIST_BY_PARATYPE'

const parametersListAction = data => ({
  type: PARAMETERS_LIST,
  data,
});
const parametersListByParaTypeAction = data => ({
  type: PARAMETERS_LIST_BY_PARATYPE,
  data,
});
const parametersByClientAction = data => ({
  type: PARAMETERS_BY_CLIENT,
  data,
});

const parametersByIDAction = data => ({
  type: PARAMETERS_BY_ID,
  data,
});

export const parametersList = payload => async dispatch => {
  dispatch({ type: PARAMETERS_LIST_PROGRESS });
  const authOptions = {
    method: 'GET',
    url: `${API_URL}parametersList`,
    params: {
      clientId: payload.clientId,
      lang: payload.lang
    },
    headers: {
      'Authorization': payload.tokenType + ' ' + payload.accessToken,
      'Content-Type': 'application/json'
    }
  }
  await axios(authOptions)
    .then(res => {
      dispatch(parametersListAction(res.data))
    })
    .catch(err => {
      dispatch(parametersListAction(err))
    })
}
export const parametersListByParaType = payload => async dispatch => {
  dispatch({ type: PARAMETERS_LIST_PROGRESS });
  const authOptions = { 
    method: 'GET',
    url: `${API_URL}parametersListByParaType`,
    params:payload.data,
    headers: {
      'Authorization': payload.tokenType + ' ' + payload.accessToken,
      'Content-Type': 'application/json'
    }
  }
  axios(authOptions)
    .then(function (response) {
      dispatch(parametersListByParaTypeAction(response.data))


    })
    .catch(function (error) {
      dispatch(parametersListByParaTypeAction(error))

    });
}

export const parametersByClient = payload => dispatch => {
  const authOptions = {
    url: API_URL + 'parametersByClient',
    method: 'POST',
    data: payload.data,
    headers: {
      'Authorization': payload.tokenType + ' ' + payload.accessToken,
      'Content-Type': 'application/json'
    }
  }
  axios(authOptions).then((res) => {
    const pagination = { ...payload.pagination };
    pagination.total = res.data.totalElements;
    pagination.current = payload.data.page +1;
    let responce = {
      loading: false,
      data: res.data.content,
      pagination,
    }
    dispatch(parametersByClientAction(responce))
  }).catch((err) => {
    dispatch(parametersByClientAction(err))
  })
}

export const deleteParameters = payload => async dispatch => {
  const authOptions = {
    url: API_URL + 'deleteParameters',
    method: 'POST',
    data: payload.data,
    headers: {
      'Authorization': payload.tokenType + ' ' + payload.accessToken,
      'Content-Type': 'application/json'
    }
  }
  await axios(authOptions)
    .then((data) => {
      message.success(data.data.message);
    })
}

export const createParameters = payload => dispatch => {
  var authOptions = {
    method: 'POST',
    data: payload.data,
    url: API_URL + 'createParameters',
    headers: {
      'Authorization': payload.tokenType + ' ' + payload.accessToken,
      'Content-Type': 'application/json'
    }
  };
  axios(authOptions)
    .then(function (response) {
      if (response.data.success === true) {
        message.success(response.data.message);
        payload.history.push('/dashboard/parametersetup')
      } else if (response.data.success === false) {
        message.error(response.data.message)
      }
    })
    .catch(function (error) {
      //message.error(error.response.data.message);
    });
}

export const parametersByID = payload => async dispatch => {
  var authOptions = {
    method: 'GET',
    url: API_URL + 'parametersByID',
    params: {
      id: payload.id,
      lang: payload.lang
    },
    headers: {
      'Authorization': payload.tokenType + ' ' + payload.accessToken,
      'Content-Type': 'application/json'
    }
  }
  await axios(authOptions)
    .then(function (response) {
      if (response.data.success === true) {
        message.success(response.data.message);
        dispatch(parametersByIDAction(response.data.object))
      } else if (response.data.success === false) {
        message.error(response.data.message)
      }
    })
    .catch(function (error) {
      //message.error(error.response.data.message);
    });
}

export const updateParameters = payload => dispatch => {
  var authOptions = {
    method: 'POST',
    url: API_URL + 'updateParameters',
    data: payload.data,
    headers: {
      'Authorization': payload.tokenType + ' ' + payload.accessToken,
      'Content-Type': 'application/json'
    }
  };
  axios(authOptions)
    .then(function (response) {
      if (response.data.success === true) {
        message.success(response.data.message)
      } else if (response.data.success === false) {
        message.error(response.data.message)
      }

    })
    .catch(function (error) {
      //message.error(error.response.data.message);

    });
}